import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=86f46248&scoped=true"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=86f46248&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f46248",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuatationsSupplies/TableActions.vue
// module id = 2421
// module chunks = 31